export default __webpack_public_path__ + "f3ae3a9cbd241480b90db651993ca8fd.svg";